const React = require('react')

module.exports = (props) => (
  <button type='button' className={props.classNames.selectedTag} title='Clique para remover' onClick={props.onDelete}>
    <span className={props.classNames.selectedTagName}>{props.tag.id}</span>
  </button>
)